import { useId } from 'react'
import { Stack } from '@mui/material'
import SettingsRowCard from '@/components/Settings/SettingsRowCard'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function SettingsKpiCards({ items, intro }) {
  const headingId = useId()
  return (
    <Stack component="section" spacing={1.25} className={shared.kpiSection} aria-labelledby={headingId}>
      {intro ? <SettingsSectionIntro headingId={headingId} lines={intro} /> : null}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        useFlexGap
        className={shared.kpiCardsRow}
      >
        {items.map((kpi) => (
          <SettingsRowCard
            key={kpi.label}
            value={kpi.value}
            label={kpi.label}
            caption={kpi.caption}
            LabelIcon={kpi.LabelIcon}
            paperClassName={shared.kpiCardFlex}
            kpiDescription
          />
        ))}
      </Stack>
    </Stack>
  )
}
